class RegEx {

  static Phone = '^[0-9]{10}$';
  static Email = '^[a-zA-Z0-9._:$!%-]+[@]+[a-zA-Z0-9-_]+[.]+[a-zA-Z]+$';
  static Password = '^[a-zA-Z0-9_$@]{8,15}$';
  static Plus = '^[a-zA-Z0-9]+[ ]*[a-zA-Z0-9 ]*$';
  static Star = '^[a-zA-Z0-9 ]*$';
  static Date = '^[0-9-: ~]+$';

  static isMatch = (value, mandatory, regex) => {
    const data = value === undefined || value === null ? '' : value.toString().trim();
    const reg = regex === undefined || regex === null ? '' : regex.trim();
    if(mandatory && ( data === '' || data === '0')) return false;
    if(!mandatory && ( data === '' || data === '0')) return true;
    if(reg.length === 0) return true;
    return new RegExp(reg).test(data);
  }

  static isPhone = (phone, regex) => {
    if(regex.includes('*')) return phone === '' ? true : new RegExp(RegEx.Phone).test(phone);
    else return new RegExp(RegEx.Phone).test(phone);
  }
  static isEmail = (email, regex) => {
    if(regex.includes('*')) return email === '' ? true : new RegExp(RegEx.Email).test(email);
    else return new RegExp(RegEx.Email).test(email);
  }
  static isDate = (date, regex) => {
    if(regex === '*') return date === '' ? true : new RegExp(RegEx.Date).test(date);
    else return new RegExp(RegEx.Date).test(date);
  }
  static isFile = (files, regex) => {
    if(regex === '+') return files.length > 0;
    else return files.length >= 0;
  }

  static isPassword = password => new RegExp(RegEx.Password).test(password);
  static class = (obj, field)  => obj[field] === undefined ? '' : 'error-w';
  static classBool = field  => field ? '' : 'error-w';
  static showError = (obj, field)  => obj[field] === undefined ? null :
    <> &nbsp; : &nbsp; <label className="error-w">{obj[field]}</label></>;
  static showErrorBool = field  => field ? null :
    <> &nbsp; : &nbsp; <label className="error-w">Invalid Data</label></>;
  static isKeyPresent = (obj, field) => Object.keys(obj).find(key => key === field)!==undefined
  static getLength = obj => Object.keys(obj).length
}
export default RegEx;